/**
 * XP qoidalari (demo «Lexo v3» `XPR`). Haqiqiy XP serverda hisoblanadi (lexo-api core/xp.go: ko'paytuvchi + kunlik chegaralar);
 * bu yerdagi qiymatlar — javob kelguncha ekranda ko'rsatiladigan taxmin.
 */
import { streakNow } from '../store';

export const XPR = {
  lessonAns: 4,                                   // darsda yangi so'zga to'g'ri javob
  review: (box: number) => 3 + 2 * Math.max(1, box), // takrorlashda to'g'ri javob (5…15)
  newWord: 10,                                    // 5 bosqichni tugatgan har yangi so'z
  allRight: 15,                                   // darsni xatosiz tugatish
  goal: 40,                                       // kunlik maqsad (kuniga 1 marta)
  gameAns: 2, gameCap: 60,                        // o'yinlarda: to'g'ri javob, bitta o'yin uchun chegara
  duel: { win: 30, draw: 15, loss: 5 } as Record<'win' | 'draw' | 'loss', number>,
} as const;

/** Streak ko'paytuvchisi: 7 kun ×1.1, 14 ×1.2, 30 ×1.3, 60 ×1.5. */
export function xpMult(s = streakNow()) { return s >= 60 ? 1.5 : s >= 30 ? 1.3 : s >= 14 ? 1.2 : s >= 7 ? 1.1 : 1; }
/** Taxminiy XP (kunlik chegaralarsiz — ularni server qo'llaydi). */
export const estXp = (base: number) => Math.round(Math.max(0, base) * xpMult());

/** Unvonlar (umumiy XP bo'yicha). */
export const TITLES: Array<[number, string]> = [[0, 'Yangi boshlovchi'], [500, 'Soʻz izlovchi'], [2000, 'Soʻz ovchisi'], [5000, 'Lugʻat bilimdoni'], [12000, 'Soʻz ustasi'], [25000, 'Lexo afsonasi']];
export const titleOf = (xp: number) => TITLES.filter((x) => xp >= x[0]).at(-1)![1];
export const nextTitle = (xp: number) => TITLES.find((x) => xp < x[0]);
